import { Link } from "react-router";
import raytioMark from "~/assets/raytio-mark.svg";

type Props = {
  /** "default" = wordmark in theme text color; "footer" = white wordmark on dark. */
  variant?: "default" | "footer";
  className?: string;
};

/** The real Raytio brand mark + wordmark. */
export const Logo = ({ variant = "default", className = "" }: Props) => {
  const word = variant === "footer" ? "text-white" : "text-text-full";

  return (
    <Link to="/" className={`inline-flex items-center gap-2.5 ${className}`}>
      <img src={raytioMark} alt="" className="h-6 w-auto" aria-hidden="true" />
      <span className={`font-heading text-xl font-bold ${word}`}>Raytio</span>
    </Link>
  );
};
